import { render, staticRenderFns } from "./ChecklistSwiper.vue?vue&type=template&id=265b8e23&"
import script from "./ChecklistSwiper.vue?vue&type=script&lang=js&"
export * from "./ChecklistSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports